export const PRODUCTCLASS_GET_LIST = "/productClass";